
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TrainingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Global Training Mandate Program</h1>
          <p className="text-xl max-w-4xl mx-auto">
            A robust 60-day online training program that leads to joining the PAAM Global Workforce 
            through comprehensive apostolic education
          </p>
        </div>
      </section>

      {/* GTMP Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Global Training Mandate Program (GTMP)</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  The Global Training Mandate Program is a comprehensive 60-day online training initiative 
                  designed to equip believers with apostolic doctrine, practical ministry skills, and 
                  spiritual formation necessary for effective Kingdom service.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  This program serves as the gateway to joining the PAAM Global Workforce and becoming 
                  an active participant in the Christ Family Network. Through systematic teaching, 
                  interactive sessions, and practical assignments, participants are prepared for ministry.
                </p>
                <div className="bg-[#b8144a] text-white p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-2">Program Highlights</h3>
                  <ul className="space-y-2">
                    <li>• 60 days of intensive training</li>
                    <li>• Free access to all participants</li>
                    <li>• Interactive online platform</li>
                    <li>• Certificate upon completion</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Online%20biblical%20training%20and%20education%20platform%20with%20diverse%20students%20studying%20on%20laptops%20and%20tablets%2C%20digital%20classroom%20setting%20with%20apostolic%20teaching%20materials%2C%20modern%20e-learning%20environment%20with%20Bibles%20and%20notebooks%2C%20global%20connectivity%20theme%20with%20warm%20professional%20lighting&width=600&height=500&seq=gtmp-training-1&orientation=landscape"
                alt="GTMP Training"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Training Modules */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Training Modules</h2>
            <p className="text-xl text-gray-600">Comprehensive curriculum covering essential apostolic principles</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Foundational Doctrine</h3>
              <p className="text-gray-700 text-center mb-4">
                Core apostolic teachings, biblical foundations, and the doctrine of Christ
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Scripture interpretation</li>
                <li>• Apostolic authority</li>
                <li>• Christ-centered theology</li>
                <li>• Church order and structure</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-follow-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Discipleship Principles</h3>
              <p className="text-gray-700 text-center mb-4">
                Understanding discipleship, mentorship, and spiritual formation processes
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Making disciples</li>
                <li>• Spiritual mentoring</li>
                <li>• Character development</li>
                <li>• Leadership formation</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Spirit Empowerment</h3>
              <p className="text-gray-700 text-center mb-4">
                Operating in spiritual gifts, prayer, and supernatural ministry
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Spiritual gifts</li>
                <li>• Prayer and intercession</li>
                <li>• Divine healing</li>
                <li>• Prophetic ministry</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-megaphone-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Evangelism & Missions</h3>
              <p className="text-gray-700 text-center mb-4">
                Effective evangelism strategies and cross-cultural mission principles
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Gospel presentation</li>
                <li>• Cultural sensitivity</li>
                <li>• Church planting</li>
                <li>• Mission strategies</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-organization-chart text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Ministry Leadership</h3>
              <p className="text-gray-700 text-center mb-4">
                Leadership development, team building, and ministry administration
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Leadership principles</li>
                <li>• Team dynamics</li>
                <li>• Conflict resolution</li>
                <li>• Vision casting</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">PAAM Network</h3>
              <p className="text-gray-700 text-center mb-4">
                Understanding PAAM structure, CFN operations, and global connectivity
              </p>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• PAAM history and vision</li>
                <li>• CFN center operations</li>
                <li>• Global network structure</li>
                <li>• Partnership opportunities</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Training Format */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Training Format</h2>
            <p className="text-xl text-gray-600">Flexible learning designed for global accessibility</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-video-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Video Lessons</h4>
              <p className="text-gray-600 text-sm">High-quality video teachings from apostolic leaders</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-file-text-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Study Materials</h4>
              <p className="text-gray-600 text-sm">Comprehensive study guides and reference materials</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-group-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Live Sessions</h4>
              <p className="text-gray-600 text-sm">Interactive live sessions with instructors</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-question-answer-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Q&A Forums</h4>
              <p className="text-gray-600 text-sm">Discussion forums for questions and fellowship</p>
            </div>
          </div>
        </div>
      </section>

      {/* Enrollment Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">How to Enroll</h2>
            <p className="text-xl text-gray-600">Simple steps to begin your apostolic training journey</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Register Online</h3>
              <p className="text-gray-700">
                Complete the online registration form with your basic information and ministry interests.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Receive Access</h3>
              <p className="text-gray-700">
                Get your login credentials and access to the GTMP learning platform within 24 hours.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Begin Training</h3>
              <p className="text-gray-700">
                Start your 60-day journey with structured lessons, assignments, and fellowship.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Graduate & Serve</h3>
              <p className="text-gray-700">
                Complete the program, receive certification, and join the PAAM Global Workforce.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Training Benefits</h2>
            <p className="text-xl text-gray-600">What you gain from GTMP completion</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-award-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Official Certification</h4>
              <p className="text-gray-600">Recognized PAAM training certificate for ministry credentials</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-door-open-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Ministry Opportunities</h4>
              <p className="text-gray-600">Access to various ministry roles within the PAAM network</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-group-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Global Network</h4>
              <p className="text-gray-600">Connection with believers and leaders worldwide</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-book-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Continued Learning</h4>
              <p className="text-gray-600">Access to advanced training programs and resources</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-user-star-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Mentorship</h4>
              <p className="text-gray-600">Ongoing spiritual guidance and leadership development</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg text-center">
              <i className="ri-seedling-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Ministry Planting</h4>
              <p className="text-gray-600">Support for starting CFN centers and ministry initiatives</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Begin Your Training?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join thousands of believers worldwide who have been equipped through the Global Training 
            Mandate Program. Your apostolic journey starts here.
          </p>
          <button className="bg-white text-[#b8144a] px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            Enroll in GTMP Today - FREE
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
